<script lang="ts">
    import { Answer } from '../../types/Answer'
    import type { State } from '../../types/State'
    import type { Statement } from '../../types/Statement'
    import { Formatter } from '../../util/Formatter'

    export let path: [number, number, number, number]

    export let state: State

    export let statement: Statement

    export let simpleLanguage = false

    export let showLetter: boolean = true
</script>

<tr>
    <td class="letter">
        {#if showLetter}<div>{String.fromCharCode(65 + path[3])}.</div>{/if}
    </td>
    <td>{@html Formatter.convertLineBreaksToHTML(statement.description)}</td>
    <td class="radio small">
        <input type="radio" bind:group={state[statement.uuid].answer} value={Answer.Yes} />
        <div>Ja</div>
    </td>
    <td class="radio">
        <input type="radio" bind:group={state[statement.uuid].answer} value={Answer.MostlyYes} />
        <div>Eher Ja</div>
    </td>
    <td class="radio">
        <input type="radio" bind:group={state[statement.uuid].answer} value={Answer.MostlyNo} />
        <div>Eher Ja</div>
    </td>
    <td class="radio">
        <input type="radio" bind:group={state[statement.uuid].answer} value={Answer.No} />
        <div>Eher Nein</div>
    </td>
    <td class="radio">
        <input type="radio" bind:group={state[statement.uuid].answer} value={Answer.NotRelevant} />
        <div>
            {#if simpleLanguage}
                Weiß ich nicht
            {:else}
                Nicht relevant
            {/if}
        </div>
    </td>
</tr>

<style lang="scss">
    td {
        &.letter {
            text-align: center;
            div {
                color: var(--color-text);
                font-weight: 600;
                padding-left: 1rem;
            }
        }
        &:nth-child(2) {
            padding-top: 1.33rem;
            padding-bottom: 1.33rem;
            padding-left: 1rem;
            line-height: 1.39em;
        }
        &.radio {
            padding: 0 1.44rem;

            :global(input) {
                margin: auto;
            }

            div {
                display: none;
            }
        }
    }
    input[type='radio'] {
        display: block;
        appearance: none;
        position: relative;
        width: 1.21rem;
        height: 1.21rem;
        cursor: pointer;
        &:before {
            position: absolute;
            content: '';
            display: block;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            border-radius: 50%;
            border: solid 2px var(--color-gray-dark);
            background-color: white;
        }
        &:checked:after {
            position: absolute;
            content: '';
            display: block;
            left: 0.21rem;
            right: 0.21rem;
            top: 0.21rem;
            bottom: 0.21rem;
            border-radius: 50%;
            background-color: var(--color-primary);
        }
    }
    @media (max-width: 790px) {
        tr {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }
        td {
            display: block;
            box-sizing: border-box;

            &.letter {
                padding-top: 1.33rem;
                width: 3rem;
            }

            &:nth-child(2) {
                width: calc(100% - 3rem);
            }

            &.radio {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 21%;
                padding: 0;

                &.small {
                    width: 15%;
                }

                div {
                    display: block;
                    margin: 0.5rem 0;
                    text-align: center;
                }
            }
        }
    }
</style>
